<template>
  <div>
    <template>
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white black--text " @click="close"> close </v-btn>
        </v-toolbar>
      </v-card>
    </template>
    <v-card>
      <v-container class="fixWidth">
        <v-form ref="formVal" lazy-validation>
        <v-row>
        <!-- {{getSchema.institute_id}} -->
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="getSchema.title"
              :rules="generalRules"
              class="mt-3"
            >
            <template v-slot:label>
                  Title<strong style="color: red">*</strong>
                </template>
            </v-text-field>
           
          </v-col>
           <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.title"
                item-value="id"
                v-model="getSchema.category_id"
                chips
                :items="getInventoryCategoryItem"
                :rules="valIns"
              >
              <template v-slot:label>
                  Category Name<strong style="color: red">*</strong>
                </template>
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{
                      data.item.title
                    }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                name="Title"
                :item-text="(item) => item.institute_name_en"
                item-value="id"
                v-model="getSchema.institute_id"
                chips
                :items="getInstituteItem"
                :rules="valIns"
              >
              <template v-slot:label>
                  Institute Name<strong style="color: red">*</strong>
                </template>
                <template v-slot:selection="data">
                  <v-chip color="grey lighten-4" :input-value="data.selected">
                    <span class="subheading">{{
                      data.item.institute_name_en
                    }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
     
        
        </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            color="primary  white--text"
            @click.stop.prevent="validateBefore()"
            >{{ buttonTitle }}</v-btn
          >
          
          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
 
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";

export default {
 
  components: {
    VueEditor,
    Quill,
  },
  props: ["dialogStatus", "editedData", "indexEdited"],
  data: () => ({
  
  
    loading: false,
    dialog: false,
   
    generalRules: [
      v => !!v || "This field is required",
      ],
         valIns: [(v) => !!v || "The field is required"],
    customToolbar: [
      ["bold", "italic", "underline"], 
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
      [{ color: ["black", "red", "blue", "yellow"] }],
      ["code-block"]
    ],
  }),
  async created() {
  },
  mounted() {
    
  },
  watch: {
    dialogStatus(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
  	getInstituteItem() {
      return this.$store.getters.getInstituteItem;
    },
     getInventoryCategoryItem() {
      return this.$store.getters.getInventoryCategoryItem;
    },
    getSchema() {
      return this.$store.getters.getInventorySubCategorySchema;
    },
    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Add New Inventory Category"
        : "Update Inventory Category";
    },
    getLoaderStatus() {
      return this.$store.getters.getLoaderStatus;
    },
  },
  methods: {
    validateBefore() {
      let valid = this.$refs.formVal.validate()
      if(valid){
        this.validationForm();
      }
    },


    save() {
      let self = this;
   
      let item = this.getSchema;

      this.$store
        .dispatch("saveInventorySubCategoryData", item)
        .then(function (data) {
         

          try {
            self.close();
            self.$store.dispatch("callInventorySubCategoryList", {
                 page: 1,
                 size: 10,
            });
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function () {
         //  console.log();
        });
    },

       edit() {
      let self = this;
      let item = this.getSchema;
      this.$store
        .dispatch("editInventorySubCategory", item)
        .then(function (data) {
          self.close();
          self.$emit("update:loadData", true);
          self.$store.dispatch("callInventorySubCategoryList");
        })
        .catch(function (error) {
         //  console.log(error);
          //self.$store.dispatch("fetchCenLsDistToRegData");
        });
      this.$emit("saveText", -1);
    },
    close() {
      
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },

    validationForm() {
    
      return this.indexEdited === -1 ? this.save() : this.edit();
    
    },
    clear() {
      this.$store.commit("SET_INVENTORY_SUB_CATEGORY_SCHEMA", {});
    },
  },
};
</script>

 </script>

<style scoped>
.scroll {
  overflow-y: auto;
}
@media (min-width: 576px) {
  .form-card-size {
    max-width: 5px;
    /* width: 500px; */
  }
}
@media (min-width: 768px) {
  .form-card-size {
    max-width: 60px;
  }
}

@media (min-width: 992px) {
  .form-card-size {
    max-width: 120px;
  }
}

@media (min-width: 1200px) {
  .form-card-size {
    max-width: 300px;
  }
}

.fixWidth{
  width: auto;
}
</style>
